var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"skeleton-container",attrs:{"aria-busy":"true","aria-live":"polite"}},_vm._l((_vm.rows),function(row){return _c('div',{key:row,staticClass:"skeleton-row"},_vm._l((_vm.cols),function(col){return _c('div',{key:col,staticClass:"skeleton-cell",style:({ width: _vm.getCellWidth(col) })})}),0)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }